import type {IWindowService} from 'angular';
import type {Rec, ViewableFile} from 'typings/portaro.be.types';
import type {FileService} from '../../file/file.service';
import type {RecordCoverDataService} from './record-cover.data-service';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';
import type WalkerService from 'shared/services/walker.service';
import type CurrentAuthService from 'shared/services/current-auth.service';
import {exists} from 'shared/utils/custom-utils';
import {FileViewForm} from 'shared/constants/portaro.constants';

export class KpCoverPresenter {
    public static presenterName = 'kpCoverPresenter';

    /*@ngInject*/
    constructor(private fileService: FileService,
                private walker: WalkerService,
                private $window: IWindowService,
                private currentAuthService: CurrentAuthService,
                private recordCoverDataService: RecordCoverDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public openMediaViewer(record: Rec): Promise<string> {
        return this.walker.newPage('/media-viewer', {
            rootDirectory: record.directoryId,
            origin: this.$window.location.href
        });
    }

    public getCoverPath(record: Rec | null): string {
        if (exists(record)) {
            return this.getRecordCoverPath(record);
        } else {
            return this.getPlaceholderCoverPath();
        }
    }

    public getRecordPath(record: Rec): string {
        return `/#!/records/${record.id}`;
    }

    public async setFileAsPrimaryCover(record: Rec, file: ViewableFile): Promise<boolean> {
        if (!file.viewForms.includes(FileViewForm.IMAGE)) {
            return false;
        }

        try {
            const actionResponse = await this.recordCoverDataService.setFileAsPrimaryCover({record, file});
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
            return true;
        } catch (e) {
            this.finishedResponseInteractionService.showFailedResponseInToast(e);
            return false;
        }
    }

    public get isUserLoggedIn(): boolean {
        return this.currentAuthService.isLoggedIn();
    }

    private getRecordCoverPath(record: Rec): string {
        if (exists(record.cover) && exists(record.cover.id)) {
            return `${this.fileService.getFilePath(record.cover)}/thumbnail`;
        } else {
            return `/records/${record.id}/cover`;
        }
    }

    private getPlaceholderCoverPath(): string {
        return '/resources/img/covers/book.png';
    }
}